export const ESTIMATED_OFFER_DATA_KEYS = {
  ESTIMATE_BY_CATEGORY: 'estimateByCategory',
  ABOVE_AVERAGE: 'Above Average',
  AVERAGE: 'Average',
  BELOW_AVERAGE: 'Below Average',
  ESTIMATE: 'estimate',
  EXCELLENT: 'Excellent',
};
